import {Injectable} from '@angular/core'
import {ILoader} from './iloader'

@Injectable()
export class LoaderService {
    loader: ILoader = { isLoading: false };
    showLoader() {
        this.loader.isLoading = true;
    }
    hideLoader() {
        this.loader.isLoading = false;
    }
} 


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/loader/loader.service.ts
 **/